import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onSetSelectedPriceListBranch, selectPriceListBranchState, setAction } from "../redux/slices/priceListBranchofficeSlice"
import { priceListBranchOfficeAPI } from "../apis/priceListBranchOfficeAPI"
import { priceListBranchoffice } from "../types/slices/priceListBranchofficeType"

export const usePriceListBranchStore = () => {

    const dispatch = useDispatch()
    const { priceListBranch, priceListSelectedBranch, status, action } = useSelector(selectPriceListBranchState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getPriceListBranchoffice = async (data:{}) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await priceListBranchOfficeAPI.getPriceListBranchoffice(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createPriceListBranchoffice = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await priceListBranchOfficeAPI.createPriceListBranchoffice(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editPriceListBranchoffice = async (idlist: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await priceListBranchOfficeAPI.editPriceListBranchoffice(idlist, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deletePriceListBranchoffice = async (idlist: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await priceListBranchOfficeAPI.deletePriceListBranchoffice(idlist)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedPriceListBranch = (detail: priceListBranchoffice) => {
        try {
            dispatch(onSetSelectedPriceListBranch(detail))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionPriceListBranch = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        priceListBranch,
        priceListSelectedBranch,
        status,
        action,
        //actions
        getPriceListBranchoffice,
        createPriceListBranchoffice,
        editPriceListBranchoffice,
        deletePriceListBranchoffice,
        setSelectedPriceListBranch,
        setActionPriceListBranch,
    }
}